require('./brokerIndexValuesView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const BrokerMainStocksSelector = require('components/broker/brokerMainStocksSelector/brokerMainStocksSelector');
const BrokerMainStocksResultsList = require('components/broker/brokerMainStocksResultsList/brokerMainStocksResultsList');
// @ utilities
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
// @ actions
const brokerTodaysMainStocksActions = require('actions/brokerTodaysMainStocks');

class BrokerIndexValuesView extends React.Component {

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleSelectorChange = this.handleSelectorChange.bind(this);
        this.requestIndexes = this.requestIndexes.bind(this);
        this.requestStocks = this.requestStocks.bind(this);

        this.state = {
            selectedMarket: props.match.params.marketId || ''
        };
        this.breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerMarkets'),
                url: `/myprofile/broker/markets`
            },
            {
                text: formatText('breadcrumb-brokerIndexValues')
            }
        ];
    }

    componentDidMount() {
        this.requestIndexes();
    }

    componentDidUpdate(prevProps) {
        const selectedMarket = this.state.selectedMarket;
        const { immBrokerExchangeIndexes } = this.props;

        // (Andres): I am checking that the old prop is false, so we make sure this executes only one time.
        // We don't need this after every change in the dropdown
        if (!prevProps.immBrokerExchangeIndexes.get('hasBeenFetched') && immBrokerExchangeIndexes.get('hasBeenFetched') && selectedMarket) {
            this.requestStocks(selectedMarket)
        }
    }

    handleSelectorChange(params) {
        const { immBrokerExchangeIndexes, getStocksByIndex, history } = this.props;
        const { selectedMarket } = params;

        this.setState({
            selectedMarket: selectedMarket
        }, () => {
            history.push(`/myprofile/broker/index-values/${selectedMarket}`);
        });

        const selectedItem = immBrokerExchangeIndexes.get('indexes').find(item => item.get('name') === selectedMarket);

        if (!selectedItem) {
            return;
        }

        getStocksByIndex({
            exchangeId: selectedItem.get('exchangeId'),
            spcSymbol: selectedItem.get('spcSymbol'),
            selectedMarket: selectedMarket
        });
    }

    requestIndexes() {
        this.props.getIndexes();
    }

    requestStocks(selectedMarket) {
        this.handleSelectorChange({ selectedMarket });
    }

    render() {
        const { immBrokerExchangeIndexes } = this.props;
        const { selectedMarket } = this.state;
        const searchUrl = '/myprofile/broker/explore';
        const stocksByIndex = immBrokerExchangeIndexes.getIn(['byId', selectedMarket]);

        return (
            <article className="broker-index-values-view">
                <OKCover size="medium" section="broker">
                    <OKHeaderSubPage
                        breadcrumbConfig={this.breadcrumb}
                        finalTitle={getFinalTitle('broker-indexValuesTitle')}
                    >
                        <OKButton
                            inverse={true}
                            modifier="ghost"
                            to={searchUrl}
                        >
                            <FormattedText value="broker-indexValuesSearch" />
                        </OKButton>
                    </OKHeaderSubPage>
                </OKCover>
                <section className="broker-index-values-view__body">
                    <div className="row no-outside-gutter">
                        <section className="col-xs-12">
                            <OKSectionBox
                                title={formatText('broker-indexValuesSelectorTitle')}
                            >
                                <BrokerMainStocksSelector
                                    label="broker-indexValuesSelectorLabel"
                                    immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                                    selectedMarket={selectedMarket}
                                    onChange={this.handleSelectorChange}
                                    requestIndexes={this.requestIndexes}
                                />
                            </OKSectionBox>

                            <BrokerMainStocksResultsList
                                titlePrefix="broker-indexValuesIndexesTitlePrefix"
                                hasControls={false}
                                hasFilter={true}
                                immTodaysMainStocks={stocksByIndex}
                                selectedMarket={selectedMarket}
                                requestStocks={this.requestStocks}
                                immBrokerExchangeIndexes={immBrokerExchangeIndexes}
                            />
                        </section>
                    </div>
                </section>
            </article>
        );
    }
}


BrokerIndexValuesView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerExchangeIndexes: PropTypes.object.isRequired,
    getIndexes: PropTypes.func.isRequired,
    getStocksByIndex: PropTypes.func.isRequired
};

module.exports.constructor = BrokerIndexValuesView;
module.exports.BrokerIndexValuesView = connect(
    state => ({
        immBrokerExchangeIndexes: state.brokerExchangeIndexes
    }), {
    getStocksByIndex: brokerTodaysMainStocksActions.getStocksByIndex,
    getIndexes: brokerTodaysMainStocksActions.getIndexes,
}
)(withRouter(BrokerIndexValuesView));
